import { EntityTypeConfigurationHelper, EntityTypeConfigurationModel } from '../../../../../../models/basics/basics.models';
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { autoinject } from "aurelia-dependency-injection";
import { CustomerVesselService } from '../../../../../../services/vessels/customer-vessels.service';
import { ChangeCustomerVessel } from '../../../../../../models/vessels/customer-vessel.models';
import { NotificationClientService, NotificationType } from '../../../../../../services/basics/notification-client.service';
import { ValidationController, ValidationControllerFactory, ValidationRules } from 'aurelia-validation';
import { CustomValidationRenderer } from '../../../../../../client-validation-system/custom-validation-renderer';
import { ManageVesselService } from "../../../../../../services/vessels/manage-vessel.service";
import { GetVesselRequest } from "../../../../../../models/vessels/vessel.models";
import { CustomerSubscriptionModel, SubscriptionProductCodes } from "../../../../../../models/customers/customer-subscription.models";
import { ChangeCustomerVesselsResponse } from '../../../../../../models/vessels/customer-vessel.models';
import { ValidationsClientService } from "../../../../../../services/validations/validations-client.service";
import { SubscriptionHelper } from '../../helpers/subscription-helper';
import { computedFrom } from 'aurelia-binding';

@autoinject
export class ChangeVesselSubscriptionDialog {

    private _onSaved: () => void;
    private validator: ValidationController;
    public confirmation: boolean;
    public vesselEntityTypeConfigurationModel: EntityTypeConfigurationModel[];
    public fromVessel: any;
    public selectedVessel: any;
    public customerSubscription: CustomerSubscriptionModel;
    public customerId: number;

    @computedFrom('customerId', 'customerSubscription.productCode')
    get searchBag() {
        return this.customerSubscription.productCode == SubscriptionProductCodes.informationServices ? undefined : `my-vessels-pscriskiq-${this.customerId}`;
    }

    constructor(private dialogClientService: DialogClientService, private entityTypeConfigurationHelper: EntityTypeConfigurationHelper,
        private customerVesselService: CustomerVesselService, validationControllerFactory: ValidationControllerFactory,
        private notificationClientService: NotificationClientService, private manageVesselClientService: ManageVesselService,
        private validationsClientService: ValidationsClientService, private subscriptionHelper: SubscriptionHelper) {
        
        this.validator = validationControllerFactory.createForCurrentScope();
        this.validator.addRenderer(new CustomValidationRenderer());
        this.vesselEntityTypeConfigurationModel = this.entityTypeConfigurationHelper.getConfigurationByKey(["AllVesselSearch"]).filter(x => x.key == "AllVesselSearch");
        
    }

    activate(model: { onSaved: () => void , vesselId: number, customerSubscription: CustomerSubscriptionModel, customerId }) {
        this.manageVesselClientService.getVessel({ vesselId: model.vesselId } as GetVesselRequest).then(x => {
            this.fromVessel = x.vessel;
        });
        this._onSaved = model.onSaved;
        this.customerSubscription = model.customerSubscription;
        this.customerId = model.customerId;
    }

    cancel() {
        this.dialogClientService.hide();
    }

    async save() {
        if (this.fromVessel.id === this.selectedVessel?.id) {
            this.notificationClientService.show("Cannot change the same vessel", "", NotificationType.Error);
            return;
        }

        this.setRules();
        try {
            const validationResult = await this.validator.validate();
            if (validationResult.valid) {

                const changeCustomerVessels: ChangeCustomerVessel[] = [];
                changeCustomerVessels.push({
                    fromVesselId: this.fromVessel.id,
                    toVesselId: this.selectedVessel.id
                } as ChangeCustomerVessel);
        
                await this.customerVesselService.changeCustomerVessels({
                    changeCustomerVessels: changeCustomerVessels,
                    customerId: this.customerId,
                    productCode: this.customerSubscription.productCode
                }).then((response: ChangeCustomerVesselsResponse)=> {
                    if (response.validationResult && response.validationResult.hasError) 
                    { 
                        this.validationsClientService.showValidationErrors(response.validationResult);
                    } else {
                        this.dialogClientService.hide();
                        this.notificationClientService.show("Vessel changed successfully!", "", NotificationType.Success);
                        this._onSaved();
                    }
                });
            }
        } catch (e) {
            console.error("Failed to change customer vessels", e);
        }
    }

    vesselSelected(index: number, event: any) {
        if (!event.detail.selectedEntity)
            return;

        this.customerVesselService.doesCustomerHaveAccessToVessel({
            vesselId: event.detail.selectedEntity.id,
            customerId: this.customerId
        }).then((canAdd: boolean) => {
            if (!canAdd && this.customerSubscription.productCode == SubscriptionProductCodes.pscRiskIqInApp)
                this.notificationClientService.show("The selected vessel is not subscribed to Information Services and cannot be added to PSC RiskIQ. Please subscribe to Information Services first and try again.", "", NotificationType.Error);
            else
                this.selectedVessel = event.detail.selectedEntity;
        });
    }

    removeSelectedVessel() {
        this.selectedVessel = null;
    }

    setRules() {
        ValidationRules
            .ensure<ChangeVesselSubscriptionDialog, boolean>(x => x.confirmation)
            .required()
            .withMessage("Confirmation is required")
            .on(this);

        this.validator.reset();
        this.validator.addObject(this);
    }

    upgradeSubscription() {
        const url: string = this.subscriptionHelper.getUpgradeSubscriptionUrl();
        window.open(url, "_blank");
    }
}